import { Editor as CoreEditor, EventInfo } from "ckeditor5";

export type Editor = CoreEditor;

export type EditorVariant = "inline" | "classic" | "seamless";

export interface DocumentChangeEventInfo
  extends EventInfo<"change" | "change:data"> {
  state?: {
    isDataController: boolean;
  };
}

export const isChangeEventInfo = (
  e: EventInfo,
): e is DocumentChangeEventInfo => {
  return e.name === "change" || e.name === "change:data";
};
